import { observer } from 'mobx-react';

import { ChooseCountryComponentRedesign } from '../redesign-components/ChooseCountryRedesign/ChooseCountryComponentRedesign';

import { ChooseCountryComponent } from './ChooseCountryComponent';
import type { ChooseCountryProps } from './types';

const ChooseCountry = observer(function ChooseCountry(props: ChooseCountryProps) {
  const isRedesignFlow = props.wizardFlowParams?.isRedesignSteps === true;
  if (!isRedesignFlow) {
    return <ChooseCountryComponent {...props} />;
  }
  return <ChooseCountryComponentRedesign {...props} />;
});

export default ChooseCountry;
